import { Component, HostListener } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ProfessionalExperiencesViewsDialogComponent } from 'src/components/professional-experiences-views-dialog/professional-experiences-views-dialog.component';
import { ProfessionalExperiencesComponent } from 'src/components/professional-experiences/professional-experiences.component';
import { SchoolingComponent } from 'src/components/schooling/schooling.component';
import { ErrorReportService } from 'src/services/error-report.service';
import { GoogleAuthService } from 'src/services/google-calendar.service';
import { HttpService } from 'src/services/http.service';
import { NotificationService } from 'src/services/notification.service';
import { OneSignalService } from 'src/services/onesignal.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'colloca';
  user: any;
  notifications: any[] = [];
  isNotificationPanelOpen = false;
  checknotif = false;
  colors = false;
  trialDate: any;
  private subscription: Subscription;
  showVersionLink: boolean = true;


  constructor(
    private dialog: MatDialog,
    private router: Router,
    private http: HttpService,
    private snackbar: MatSnackBar,
    private notificationService: NotificationService,
    private oneSignalService: OneSignalService,
    private errorReport: ErrorReportService,
    private googleAuthService: GoogleAuthService,
  ) {

    //this.user = JSON.parse(localStorage.getItem('token'));
    //console.log(this.user);

    const wObject = (window as any);
    this.dialog
      .afterOpened
      .subscribe(
        (dialog: MatDialogRef<any>) => {          
          wObject.setPushEvent({
            type: 'dialog',
            dialog
          }, true)
        }
      )
    this.dialog
      .afterAllClosed
      .subscribe(
        () => {
          wObject.setPushEvent({
            type: 'url',
            data: null
          })
        }
      )
    this.router.events
      .subscribe(
        event => {
          if(event instanceof NavigationEnd) {            
            
            wObject.setPushEvent({
              type: 'url',
              url: event.url
            }, false)

            if(wObject.IS_FLUTTER)
              wObject.generateFocusInput();            

          }
        }
      )

      this.router.events.subscribe(() => {
        // Verifica a rota ativa
        const currentRoute = this.router.url;
  
        // Esconde o VersionLinkComponent para CustomerPanel e Recruiter
        this.showVersionLink = !(
          currentRoute.includes('customer') || 
          currentRoute.includes('recruiter')
        );
      });
  }

  ngOnInit(): void {
  //   this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => { 
  //     this.verificaCad();
  //   });

    setInterval(() => {
      this.verifyEmailPeriodically();
    //  }, 120000);  
    }, 1 * 60 * 60 * 1000); // 1 hora em milissegundos

    this.oneSignalService.notifications$.subscribe(notifications => {
        this.notifications = notifications;
    });

    this.listNotifications();

    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      // Atualiza as condições quando a rota muda
      const url = this.router.url;

      if (
        url.includes('/auth/login') ||
        url.includes('/auth/password') ||
        url.includes('/register') ||
        url.includes('/register/company') ||
        url.includes('/shared-process')
      ) {
        this.checknotif = false;
      } else {
        this.checknotif = true;
        this.colors = url.includes('/customer/');
      }
    });

  }

  verifyEmailPeriodically() {
    
    const token = localStorage.getItem('token');
  
    if (token) {
      const currentUser = JSON.parse(token);
      const email = currentUser?.email;
      const status = currentUser?.signature_status;

      if (email && status == 'TRIAL') {
    
        const data = { email: email };

        this.http.save('company:period', data)
          .subscribe(
            (result: any) => {
              if (result.data) {
                //console.log('periodo', result.data);
                localStorage.setItem('token', JSON.stringify(result.data));
                // window.location.reload();
              } else {
                console.error('erro no periodo');
              }
            },
            err => console.error('Erro Temporizador Payment:', err)
          );
      }
    
    }
    
  }

  // verificaCad(){
  //   //Verificação do cadastro
  //   if(this.user){
  //     if (!this.router.url.includes('/auth/login')) {
  //       if ((this.user.mostrar_experiencias == null && ( this.user.signature_plan_id == null || !this.user.signature_plan_id.includes('BUSINESS') ))) {
  //         console.log('aqui')
  //         this.getProfessional();
  //       }
  //     }
  //   }

  // }

  // experiences
  // getProfessional() {

  //   const params = {
  //     id: this.user.id,
  //     all: true
  //   }
  //   this.http.get('experience', params)
  //     .subscribe(
  //       (result: any) => {
      
  //         this.experiences = result.data.slice(0, 3);
  //         if(this.experiences.length == 0){

  //           this.dialog.open(
  //             ProfessionalExperiencesComponent,
  //               {
  //                 width: '600px',
  //                 disableClose: false,
  //                 data: {
  //                   message: 'Parece que você ainda não cadastrou uma experiência profissional, finalize o seu cadastro para que as empresas possam encontrar o seu currículo.'
  //                 }
  //               }
  //             );

  //           }else{  
  //             this.getEducation(); 
  //           }

  //       },
  //       (err: any) => {          
  //         console.log(err);
  //       }
  //     )

  // }

  // educations
  // getEducation() {

  //   const params = {
  //     id: this.user.id,
  //     all: true
  //   }
  //   this.http.get('education', params)
  //     .subscribe(
  //       (result: any) => {
          
  //         this.educations = result.data.slice(0, 3);
          
  //         if(this.educations.length == 0){
  //           this.dialog.open(
  //             SchoolingComponent,
  //               {
  //                 width: '600px',
  //                 disableClose: false,
  //                 data: {
  //                   message: 'Parece que você ainda não cadastrou o seu histórico escolar, finalize o seu cadastro para que as empresas possam encontrar o seu currículo.'
  //                 }
  //               }
  //           );
  //         }
            

  //       },
  //       (err: any) => {
  //         console.log(err);
  //       }
  //     )

  // }

  toggleNotificationPanel() {
    this.isNotificationPanelOpen = !this.isNotificationPanelOpen;
  }

  getUnreadCount(): number {
    return this.notifications.filter(notification => notification.unread).length;
  }

  allNotificationsRead(): boolean {
    return this.notifications.every(notification => !notification.unread);
  }

  notificationRead(id: string): void {
    this.notifications.forEach(notification => {
      if (notification.id === id) {
        notification.unread = false;
        this.http.save('onsignal:readNotification', { id: id })
          .subscribe(
            (result: any) => {
              if (result.type === 'OK') {
                this.getUnreadCount();                
              }
            },
            err => console.error('Erro ao marcar como lida a notificação:', err)
          );
      }
    });
  }

  markAllAsRead(): void {
    this.notifications.forEach(notification => {
      notification.unread = false;
    });
    const user = JSON.parse(localStorage.getItem('token'));
    this.http.save('onsignal:allReadNotification', { id: user.id })
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.getUnreadCount(); // Atualiza a contagem de notificações não lidas, se necessário
          }
        },
        err => console.error('Erro ao marcar como lida a notificação:', err)
      );
  }

  toggleMessage(notification: any, event: Event): void {
    event.stopPropagation(); // Para evitar que o clique na mensagem marque como lida
    notification.isExpanded = !notification.isExpanded;
  }

  listNotifications(){
    this.oneSignalService.listNotification();
  }
  
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedElement = event.target as HTMLElement;
    const notificationPanel = document.querySelector('.notification-panel');
    const notificationBell = document.querySelector('.notification-bell');

    // Verifica se o painel está aberto e se o clique foi fora dele e do sino
    if (
      this.isNotificationPanelOpen &&
      notificationPanel &&
      !notificationPanel.contains(clickedElement) &&
      notificationBell &&
      !notificationBell.contains(clickedElement)
    ) {
      this.isNotificationPanelOpen = false; // Fecha o painel
    }
  }

}